import * as React from 'react'
import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { useReviewShowContext } from 'modules/reviews/pages/performance/Show/hooks'

import AnswersAvailability from './AnswersAvailability'
import CycleConfiguration from './CycleConfiguration/CycleConfiguration'
import EditorsSection from './Editors/EditorsSection'
import PrivacySettings from './PrivacySettings'
import ReviewBasicInfo from './ReviewBasicInfo'

const border = {
  width: 's1',
  style: 'solid',
  color: 'grey400',
} as const

interface Props {
  contractVersions: ContractVersions
}

function ReviewSettings({ contractVersions }: Props) {
  const { review } = useReviewShowContext()

  return (
    <>
      <ReviewBasicInfo />
      <Box
        border={{
          top: border,
        }}
      >
        <CycleConfiguration review={review} />
      </Box>
      <Box
        border={{
          top: border,
        }}
      >
        <PrivacySettings form={review} canBeAnonymous />
      </Box>
      <Box
        border={{
          top: border,
        }}
      >
        <AnswersAvailability form={review} />
      </Box>
      <Box
        border={{
          top: border,
        }}
      >
        <EditorsSection review={review} contractVersions={contractVersions} />
      </Box>
      <Outlet context={{ review }} />
    </>
  )
}

export default observer(ReviewSettings)
